module.exports = __webpack_public_path__ + "img/1537539634.ee2f51fd.jpg";